import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


export type SeeInformationAs = "grid" | "card";

export interface AuthState {
    connectionId: string | null;
    token: string | null;
    moduleId: string | null;
    userId: string | null;
}

const initialState: AuthState = {
    connectionId: null,
    token: null,
    moduleId: null,
    userId: null,
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setIdConnection: (state, action: PayloadAction<string>) => {
            state.connectionId = action.payload;
            localStorage.setItem("connectionId", action.payload);
        },
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload.replaceAll(' ', '+');
            localStorage.setItem("token", action.payload);
        },
        setUserId: (state, action: PayloadAction<string>) => {
            state.userId = action.payload;
            localStorage.setItem("userId", action.payload);
        },
        setModuleId: (state, action: PayloadAction<string>) => {
            state.moduleId = action.payload;
            localStorage.setItem("moduleId", action.payload);
        },
    }
})


export const { 
    setIdConnection,
    setToken,
    setModuleId,
    setUserId,
} = authSlice.actions
